import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CoreRoute } from '@app/core/constants';
import { AuthService } from '@app/core/services';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(): boolean | UrlTree {
    if (this.authService.getToken()) {
      return this.router.createUrlTree([CoreRoute.Shelf]);
    }
    return true;
  }
}
